import { makeStyles } from "@material-ui/styles";

const addPlayerStyles = makeStyles((theme) => ({
	contentContainer: {
		height: "100%"
	},
	detailsContainer: {
		margin: "auto",
		display: "flex",
		justifyContent: "center",
		padding: theme.spacing(4),
		alignItems: "flex-start"
	}
}));

export default addPlayerStyles;
